const JOURNEY_FLOW_STAGE_KEY = "britannia_journey_flow_stage";

export const JOURNEY_FLOW_STAGES = {
  COMPLETE_VIDEO: "complete-video",
  COMPLETE_PACK_THEN_BISCUIT: "complete-pack-then-biscuit",
  INCOMPLETE_DASHBOARD_THEN_BISCUIT: "incomplete-dashboard-then-biscuit",
  INCOMPLETE_PACK_FIRST: "incomplete-pack-first",
  INCOMPLETE_HOME_REPEAT: "incomplete-home-repeat",
  INCOMPLETE_FINAL_VIDEO: "incomplete-final-video",
};

function getWeekStart(date) {
  const local = new Date(date);
  const day = local.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  local.setHours(0, 0, 0, 0);
  local.setDate(local.getDate() + diff);
  return local;
}

export function isJourneyComplete(user) {
  return Boolean(
    user?.lastVideoSubmittedAt ||
    user?.videoRecords?.length ||
    user?.userVideos?.length
  );
}

export function hasClaimedBothCashbacks(user) {
  const claimedCount = Number(
    user?.cashbackLifetimeCount ?? user?.cashbackCount ?? 0
  );
  return claimedCount >= 2;
}

export function hasScannedSku(user) {
  return Boolean(
    user?.isPackScan ||
    Number(user?.totalScans ?? 0) > 0 ||
    localStorage.getItem("machineCodeScanned") === "true"
  );
}

export function isSameBusinessWeek(dateValue) {
  if (!dateValue) return false;

  const submittedAt = new Date(dateValue);
  if (Number.isNaN(submittedAt.getTime())) {
    return false;
  }

  const now = new Date();
  return getWeekStart(submittedAt).getTime() === getWeekStart(now).getTime();
}

export function resolveSecondLoginFlow(user) {
  const totalScans = Number(user?.totalScans ?? 0);
  const cashbackCount = Number(user?.cashbackCount ?? 0);
  const totalCashback = Number(user?.totalCashback ?? 0);

  if (!user?.isOtpVerified) {
    return { route: "/batch-scan", stage: null };
  }

  // ✅ Highest priority: user has claimed both cashbacks → go home
  if (cashbackCount >= 2) {
    return { route: "/home", stage: null };
  }

  if (totalScans === 0) {
    return { route: "/batch-scan", stage: null };
  }

  if (totalScans > 0 && totalCashback === 0) {
    return { route: "/batch-scan", stage: null };
  }

  if (cashbackCount === 1 && totalCashback === 1) {
    return { route: "/home", stage: null };
  }

  if (cashbackCount === 1 && totalCashback === 0) {
    return { route: "/batch-scan", stage: null };
  }

  if (cashbackCount === 0 && totalCashback === 1) {
    return { route: "/home", stage: null };
  }

  if (cashbackCount === 0 && totalCashback === 0) {
    return { route: "/batch-scan", stage: null };
  }

  return {
    route: totalCashback > 0 ? "/home" : "/batch-scan",
    stage: null,
  };
}

export function setJourneyFlowStage(stage) {
  if (!stage) {
    clearJourneyFlowStage();
    return;
  }
  sessionStorage.setItem(JOURNEY_FLOW_STAGE_KEY, stage);
}

export function getJourneyFlowStage() {
  return sessionStorage.getItem(JOURNEY_FLOW_STAGE_KEY);
}

export function clearJourneyFlowStage() {
  sessionStorage.removeItem(JOURNEY_FLOW_STAGE_KEY);
}

export function getPostPackScanTarget() {
  const currentStage = getJourneyFlowStage();

  if (currentStage === JOURNEY_FLOW_STAGES.COMPLETE_PACK_THEN_BISCUIT) {
    setJourneyFlowStage(JOURNEY_FLOW_STAGES.COMPLETE_VIDEO);
    return "/biscuit-scan";
  }

  if (currentStage === JOURNEY_FLOW_STAGES.INCOMPLETE_PACK_FIRST) {
    setJourneyFlowStage(JOURNEY_FLOW_STAGES.INCOMPLETE_HOME_REPEAT);
    return "/biscuit-scan";
  }

  return "/home";
}

export function getPostBiscuitScanTarget() {
  const currentStage = getJourneyFlowStage();

  if (
    currentStage === JOURNEY_FLOW_STAGES.COMPLETE_VIDEO ||
    currentStage === JOURNEY_FLOW_STAGES.INCOMPLETE_DASHBOARD_THEN_BISCUIT ||
    currentStage === JOURNEY_FLOW_STAGES.INCOMPLETE_FINAL_VIDEO
  ) {
    return "/share-video";
  }

  if (currentStage === JOURNEY_FLOW_STAGES.INCOMPLETE_HOME_REPEAT) {
    setJourneyFlowStage(JOURNEY_FLOW_STAGES.INCOMPLETE_FINAL_VIDEO);
    return "/home";
  }

  return "/home";
}
